import { Injectable } from "@angular/core";
import { CanActivate, Router, UrlTree } from "@angular/router";
import { ConfigService } from "../../services/env-config.service";
import { map, Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
export class MaintenanceGuard implements CanActivate {

constructor (
    private configService: ConfigService,
    private router: Router
 ) {}

 canActivate(): Observable<boolean | UrlTree> {
   return this.configService.getConfig().pipe(
     map((config: any) => {
       if (config.maintenanceMode) {
         return this.router.parseUrl('/maintenance');
       }
       return true;
     })
   );
 }
}